import appStrings from '@/app/utility/string.utility';
import DatePicker from 'vue2-datepicker';
import commonModalOracle from '../../commonModalOracle';
import commonHelper from '@/app/utility/common.helper.utility';
import { required } from 'vuelidate/lib/validators';
export default {
  name: 'addProvisions',
  components: {
    appStrings,
    DatePicker,
    commonModalOracle
  },
  watch: {
    currentPage: function () {
      this.getCarryForwardDetailData();
    },
    perPage: function () {
      this.currentPage = 1;
      this.getCarryForwardDetailData();
    },
    updateCurrentPage: function () {
      this.getUpdatedCarryForwardDtlById();
    },
    updatePerPage: function () {
      this.updateCurrentPage = 1;
      this.getUpdatedCarryForwardDtlById();
    },
    selectAllCheckBox: function () {
      this.checkUncheckAll();
    },
    selectAllCheckBoxAdd: function () {
      this.checkUncheckAllAdd();
    }
  },
  props: ['carryForwardRowDetails', 'wfCarryForwardDetails'],
  data() {
    return {
      totalRows: null,
      currentPage: 1,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      updateTotalRows: null,
      updateCurrentPage: 1,
      updatePerPage: commonHelper.perPageRecord,
      loader: false,
      editMode: false,
      showAlert: false,
      successMsg: null,
      responseMsg: '',
      isSuccess: false,
      defaultValue: {
        value: null,
        text: null
      },
      addCarryForwardData: [{
        // cf_dtl_id: 0,
        cf_amount: null,
        prov_hdr_id: null,
        prov_dtl_id: null,
        erp_org_id: null,
        vendor_code: null,
        vendor_name: null,
        po_number: null,
        po_line_number: null,
        lob: null,
        account_code: null,
        cost_centre: null,
        department: null,
        period: null,
        amount: null
      }],
      addCarryForwardFields: [
        {
          key: 'select',
          stickyColumn: true,
          variant: 'primary'
        },
        {
          key: 'le_name',
          label: 'Legal Entity'
        },
        {
          key: 'vendor_name',
          label: 'Vendor'
        },
        {
          key: 'po_number',
          label: 'PO Number'
        },
        {
          key: 'po_line_number',
          label: 'PO Line Number'
        },
        {
          key: 'lob'
        },
        {
          key: 'department'
        },
        {
          key: 'cost_centre',
          label: 'Cost Center'
        },
        {
          key: 'account_code'
        },
        {
          key: 'period'
        },
        {
          key: 'amount'
        },
        {
          key: 'cf_amount',
          label: 'Carry Forward Amount'
        },
        // {
        //   key: 'cf_period',
        //   label: 'Carry Forward Period'
        // }
      ],
      selectAllCheckBox: false,
      selectAllCheckBoxAdd: false,
      updateCarryForwardData: [],
      updateCarryForwardFields: [
        {
          key: 'select',
          stickyColumn: true,
          variant: 'primary'
        },
        {
          key: 'le_name',
          label: 'Legal Entity'
        },
        {
          key: 'vendor_name',
          label: 'Vendor'
        },
        {
          key: 'po_number',
          label: 'PO Number'
        },
        {
          key: 'line_number',
          label: 'PO Line Number'
        },
        {
          key: 'lob'
        },
        {
          key: 'department'
        },
        {
          key: 'cost_centre',
          label: 'Cost Center'
        },
        {
          key: 'account_code'
        },
        {
          key: 'period'
        },
        {
          key: 'amount'
        },
        {
          key: 'cf_amount',
          label: 'Carry Forward Amount'
        },
        // {
        //   key: 'cf_period',
        //   label: 'Carry Forward Period'
        // }
      ],
      legalEntity: {
        text: null,
        value: null
      },
      vendorName: {
        text: null,
        value: null
      },
      poNum: null,
      costCenter: null,
      concatenatedSegment: {
        text: null,
        value: null
      },
      accountNo: null,
      cfHdrId: 0,
      approvalStatus: 'DRAFT',
      glPostingStatus: 'DRAFT',
      // batchNo: null,
      showValueSetModal: false,
      parent_value_set_id: null,
      periodFrom: null,
      periodTo: null,
      department: {
        text: null,
        value: null
      },
      lob: null,
      batchName: null,
      cfPeriod: null,
      modalType: null,
      showCommonModal: false,
      vendorCode: null,
      poNumber: null,
      stateCode: null,
      expenseMonth: null,
      showExcelUploadModal: false,
      showApproveRejectModal: false,
      approvRejectType: null,
      approvalReason: null,
      rejectedReason: null,
      approvalRemarks: null,
      rejectionRemarks: null,
      urlSummaryData: null,
      wfApprovalStatus: null,
      approvalStatusKey: null,
      oraclePostingStatus: null,
      ouName: null,
      requestName: null,
      respName: null,
      leIdRequest1: null,
      pathRequest2: null,
      hdrIdRequest3: null,
      legalEntityValue: null,
    };
  },
  validations: {
    legalEntity: {
      text: { required }
    },
    periodFrom: { required },
    periodTo: { required }
  },
  mounted() {
    if (this.carryForwardRowDetails) {
      // from grid
      this.cfHdrId = this.carryForwardRowDetails.cf_hdr_id;
      this.getUpdatedCarryForwardDtlById();
      this.getCarryForwardHdrById();
    }
    else {
      this.editMode = true;
    }
    if (this.wfCarryForwardDetails) {
      // from dashboard
      this.cfHdrId = this.wfCarryForwardDetails.cf_hdr_id;
      this.getUpdatedCarryForwardDtlById();
      this.getCarryForwardHdrById();
    }
    if (this.$route.params.summaryData) {
      this.urlSummaryData = JSON.parse(
        Buffer.from(this.$route.params.summaryData, 'base64').toString('ascii')
      );
    }
    if (this.urlSummaryData) {
      // from link
      this.cfHdrId = this.urlSummaryData.cf_hdr_id;
      this.getUpdatedCarryForwardDtlById();
      this.getCarryForwardHdrById();
    }
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          if (this.approvalStatus === 'DRAFT' || this.approvalStatus === 'REJECTED') {
          this.addEditCarryForwardAmt();
          }
        }
        if (actionName === 'update') {
          this.editMode = true;
        } else if (
          actionName === 'upload' &&
          !this.showAddCarryForwardFlag &&
          !this.showCommonModal
        ) {
          this.showHideExcelUpload(true);
        }
        if (actionName === 'download') {
          this.getUpdatedCarryForwardDtlById(true);
          // this.loader = true;
          // /**
          //  * @param(payload, 'action name', 'file name')
          //  */
          // const downloadpayload = { ...this.payload };
          // downloadpayload._limit = this.updateTotalRows;
          // this.downloadExcel.downloadData(
          //   downloadpayload,
          //   'provisionsAdmin/getUpdatedCarryForwardDtlById',
          //   'carry-forward',
          //   () => (this.loader = false),
          //   this.updateCarryForwardData
          // );
        }
      }
    });
  },
  methods: {
    validateAmt(item) {
      item.cf_amount = parseFloat(item.cf_amount).toFixed(2);
      const tempVal = parseInt(item.cf_amount);
      if (tempVal > 0) {
        if (tempVal >= parseInt(item.amount)) {
          item.cf_amount = null;
          alert('Carry Forward Amount Should not be greater than Amount');
        }
      }
    },
    validateUpdateAmt(item) {
      item.cf_amount = parseFloat(item.cf_amount).toFixed(2);
      const tempVal = parseInt(item.cf_amount);
      if (tempVal > 0) {
        if (tempVal >= parseInt(item.amount)) {
          item.cf_amount = null;
          alert('Carry Forward Amount Should not be greater than Amount');
        }
      }
    },
    showHideExcelUpload(flag) {
      this.showExcelUploadModal = flag;
      if(!flag){
        this.getCarryForwardDetailData();
        this.getUpdatedCarryForwardDtlById();
      }
    },
    checkUncheckAllAdd() {
      this.addCarryForwardData = this.addCarryForwardData.map(data => {
        data.select = this.selectAllCheckBoxAdd;
        return data;
      });
    },
    checkUncheckAll() {
      this.updateCarryForwardData = this.updateCarryForwardData.map(data => {
        data.select = this.selectAllCheckBox;
        return data;
      });
    },
    getCarryForwardHdrById() {
      const payload = {
        cf_hdr_id: this.cfHdrId,
        requestPayload: {
          userId: this.$store.state.auth.userId
        }
      }
      this.loader = true;
      this.$store
        .dispatch('provisionsAdmin/getCarryForwardHdrById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page[0];
            this.wfApprovalStatus = result.approval_status_key;
            this.approvalStatusKey = result.approval_status_key;
            this.oraclePostingStatus = result.oracle_posting_status;
            this.totalCredit = result.credit;
            this.totalDebit = result.debit;
            if (result) {
              this.fillRecordFromParent(result);
            }
            this.getUpdatedCarryForwardDtlById();
            if (this.approvalStatus === 'APPROVED' && !this.oraclePostingStatus) {
              this.getApprovedBatchCarryForward();
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // setFielsForProvision(item) {
    //   this.legalEntity.text = item.le_name;
    //   this.legalEntity.value = item.erp_org_id;
    //   this.currency = item.currency;
    //   this.periodFrom = item.provision_period;
    //   this.periodTo = item.period_to;
    //   this.batchName = item.batch_name;
    //   this.approvalStatus = item.approval_status;
    //   this.addCarryForwardData = item.po_type_details;
    //   this.rowCount = item.line_count;
    // },
    getUpdatedCarryForwardDtlById(download) {
      this.payload = {
        cf_hdr_id: this.cfHdrId,
        requestPayload: {
          _page: this.currentPage - 1,
          _limit: this.perPage,
        }
      }
      this.loader = true;
      this.$store
        .dispatch('provisionsAdmin/getUpdatedCarryForwardDtlById', this.payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.updateCarryForwardData = resp.data.data.page;
            // this.updateTotalRows = resp.data.data.total_elements;
            const result = resp.data.data.page;
            if (download) {
              const customDownloadData = result.map((ele) => ({
                cf_hdr_id: ele.cf_hdr_id,
                cf_dtl_id: ele.cf_dtl_id,
                erp_org_id: ele.erp_org_id,
                legal_entity: ele.le_name,
                vendor_name: ele.vendor_name,
                po_number: ele.po_number,
                line_number: ele.line_number,
                lob: ele.lob,
                cost_centre: ele.cost_centre,
                department: ele.department,
                account_code: ele.account_code,
                cf_period: ele.cf_period,
                cf_amount: ele.cf_amount
              }));
              commonHelper.downloadExcel(
                customDownloadData,
                'carry-forward'
              )
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // setFieldsForDtl(item) {
    //   this.legalEntity.text = item.le_name;
    //   this.legalEntity.value = item.le_id;
    //   this.currency = item.currency;
    //   this.periodFrom = item.provision_period;
    //   this.periodTo = item.period_to;
    //   this.batchName = item.batch_name;
    //   this.approvalStatus = item.approval_status;
    //   this.addCarryForwardData = item.po_type_details;
    // },
    downloadExcelSearchData(){
      if(this.legalEntity.text && this.periodFrom && this.periodTo){
      this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'provisionsAdmin/getCarryForwardDetailData',
            'carry-forward',
            () => (this.loader = false),
            this.addCarryForwardData
          );
        } else{
          alert('Please Fill Mandatory Search Fields.')
        }
    },
    uploadExcelSearchData(){
      this.showHideExcelUpload(true);
    },
    getCarryForwardDetailData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.payload = {
          _page: this.currentPage - 1,
          _limit: this.perPage,
          erp_org_id: this.legalEntity.value,
          period_from: this.periodFrom,
          period_to: this.periodTo,
          vendor_name: this.vendorName.value,
          cost_center: this.costCenter,
          account_code: this.accountNo,
          lob: this.lob,
          po_number: this.poNum,
          department: this.department.text
        };
        this.loader = true;
        this.$store
          .dispatch('provisionsAdmin/getCarryForwardDetailData', this.payload)
          .then(resp => {
            this.loader = false;
            if (resp.status === 200) {
              this.addCarryForwardData = resp.data.data.page;
              for (let i = 0; i < this.addCarryForwardData.length; i++) {
                this.addCarryForwardData[i].cf_amount = null
              }
              this.totalRows = resp.data.data.total_elements;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    fillRecordFromParent(item){
     this.batchName = item.batch_name;
    //  this.batchNo = item.batch_no;
     this.cfPeriod = item.cf_period;
     this.approvalStatus = item.approval_status;
     this.glPostingStatus = item.gl_posting_status;
     this.approvalStatusKey = item.approval_status_key;
     this.wfApprovalStatus = item.approval_status_key;
    },
    addEditCarryForwardAmt() {
      if (this.cfPeriod) {
        const filterData = this.addCarryForwardData.filter(ele => ele.select);
        const filterAmt = filterData.filter(ele => {
          return !ele.cf_amount
        });
        if (filterAmt.length) {
          alert('Kindly Fill in Details Carry Forward Amount Fields.')
        } else {
          const updateAmt = filterData.map(elem => {
            return {
              cf_dtl_id: elem.cf_dtl_id ? elem.cf_dtl_id : 0,
              cf_amount: elem.cf_amount,
              prov_hdr_id: elem.prov_hdr_id,
              prov_dtl_id: elem.prov_dtl_id,
              erp_org_id: elem.erp_org_id,
              vendor_code: elem.vendor_code,
              vendor_name: elem.vendor_name,
              po_number: elem.po_number,
              po_line_number: elem.po_line_number,
              lob: elem.lob,
              account_code: elem.account_code,
              cost_centre: elem.cost_centre,
              department: elem.department,
              period: elem.period,
              amount: elem.amount,
              le_name: elem.le_name
            };
          });
          const payload = {
            cf_hdr_id: this.cfHdrId,
            approval_status: this.approvalStatus,
            gl_posting_status: this.glPostingStatus,
            // batch_no: this.batchNo,
            batch_name: this.batchName,
            cf_period: this.cfPeriod,
            cf_details: updateAmt
          };
          this.loader = true;
          this.$store
            .dispatch('provisionsAdmin/addEditCarryForwardAmt', payload)
            .then(response => {
              this.loader = false;
              this.showAlert = true;
              if (response.status === 200) {
                this.editMode = false;
                this.cfHdrId = response.data.data;
                this.getCarryForwardDetailData();
                this.getUpdatedCarryForwardDtlById();
                this.isSuccess = true;
                this.responseMsg = response.data.message;
                this.$emit('updateCarryForward');
              } else {
                this.isSuccess = false;
                this.responseMsg = response.response.data.message;
              }
            })
            .catch(() => {
              this.loader = false;
              this.isSuccess = false;
              this.responseMsg = appStrings.autoFailedMsg;
            });
        }
      }
      else {
        alert('Please Fill All Mandatory Fields.')
      }
    },
    updateCarryForwardAmt() {
      if (this.cfPeriod) {
        const filterData = this.updateCarryForwardData.filter(ele => ele.select);
        const filterAmt = this.updateCarryForwardData.filter(ele => {
          return !ele.cf_amount
        });
        if (filterAmt.length) {
          alert('Kindly Fill in Details Carry Forward Amount Fields.')
        } else {
          const updateAmt = filterData.map(elem => {
            return {
              cf_dtl_id: elem.cf_dtl_id,
              cf_amount: elem.cf_amount,
              prov_hdr_id: elem.prov_hdr_id,
              prov_dtl_id: elem.prov_dtl_id,
              erp_org_id: elem.erp_org_id,
              vendor_code: elem.vendor_code,
              vendor_name: elem.vendor_name,
              po_number: elem.po_number,
              po_line_number: elem.po_line_number,
              lob: elem.lob,
              account_code: elem.account_code,
              cost_centre: elem.cost_centre,
              department: elem.department,
              period: elem.period,
              amount: elem.amount,
              le_name: elem.le_name
            };
          });
          const payload = {
            cf_hdr_id: this.cfHdrId,
            approval_status: this.approvalStatus,
            gl_posting_status: this.glPostingStatus,
            // batch_no: this.batchNo,
            batch_name: this.batchName,
            cf_period: this.cfPeriod,
            cf_details: updateAmt
          };
          this.loader = true;
          this.$store
            .dispatch('provisionsAdmin/addEditCarryForwardAmt', payload)
            .then(response => {
              this.loader = false;
              this.showAlert = true;
              if (response.status === 200) {
                this.editMode = false;
                this.cfHdrId = response.data.data;
                this.getUpdatedCarryForwardDtlById();
                this.isSuccess = true;
                this.responseMsg = response.data.message;
                this.$emit('updateCarryForward');
              } else {
                this.isSuccess = false;
                this.responseMsg = response.response.data.message;
              }
            })
            .catch(() => {
              this.loader = false;
              this.isSuccess = false;
              this.responseMsg = appStrings.autoFailedMsg;
            });
        }
      }
      else {
        alert('Please Fill All Mandatory Fields.')
      }
    },
    mapSelectedVsetData(item) {
      if (this.modalType === 'legal_entity') {
        this.legalEntity = {
          text: item.le_name,
          value: item.le_id
        };
      } else if (this.modalType === 'period') {
        this.periodFrom = item.period_name;
      } else if (this.modalType === 'periodTo') {
        this.periodTo = item.period_name;
      } else if (this.modalType === 'expenseMonth') {
        this.cfPeriod = item.period_name;
      } else if (this.modalType === 'vendor') {
        this.vendorName.value = item.vendor_code;
        this.vendorName.text = item.vendor_name;
      } else if (this.modalType === 'po_number') {
        this.poNum = item.po_number;
        // this.getAccCodeDetails()
      } else if (this.modalType === 'account_code') {
        // this.po_distribution_id = item.po_distribution_id;
        this.concatenatedSegment.value = item.code_combination_id;
        this.concatenatedSegment.text = item.concatenated_segments;
        // this.concatenated_segments = item.concatenated_segments;
      } else if (this.modalType === 'cost_center') {
        this.costCenter = item.cost_center;
      } else if (this.modalType === 'lob') {
        this.lob = item.lob;
      } else if (this.modalType === 'account_num') {
        this.accountNo = item.account_num;
      }
      this.addCarryForwardData = JSON.parse(
        JSON.stringify(this.addCarryForwardData)
      );
      this.showHideCommonModal(false);
    },
    // newFunction() {
    //   if (this.addCarryForwardData[this.segmentIndex].state_code && this.addCarryForwardData[this.segmentIndex].cost_center && this.addCarryForwardData[this.segmentIndex].account_num && this.addCarryForwardData[this.segmentIndex].sub_account_num.toString()) {
    //     this.getLobCompanyDepartmentDetails();
    //   }
    // },
    showHideCommonModal(flag, type, index) {
      this.modalType = type;
      this.specIndex = index;
      if (flag) {
        if (this.modalType === 'po_number') {
          this.vendorCode = this.vendorName.value;
          this.legalEntityValue = this.legalEntity.value;
        } else if (this.modalType === 'account_code') {
          this.poNumber = this.poNum;
        } else if (this.modalType === 'periodTo') {
          this.periodTo = this.periodTo;
        } else if (this.modalType === 'expenseMonth') {
          this.expenseMonth = this.cfPeriod;
        } else if (this.modalType === 'cost_center') {
          this.legalEntityValue = this.legalEntity.value;
          // this.stateCode = this.state_code;
        } else if (this.modalType === 'lob') {
          this.lob = this.lob;
        }
      }
      if (this.modalType === 'cost_center' && !this.legalEntity.text) {
        this.showCommonModal = false;
        alert('Please Select Legal Entity.')
      } else if (this.modalType === 'po_number' && !this.legalEntity.text) {
        this.showCommonModal = false;
        alert('Please Select Legal Entity.')
      } 
      // else if (this.modalType === 'po_number' && !this.vendorName.text) {
      //   this.showCommonModal = false;
      //   alert('Please Select Vendor.')
      // } 
      else {
        this.showCommonModal = flag;
      }
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (
        this.vsetCode === appStrings.VALUESETTYPE.DEPARTMENT
      ) {
        this.department = {
          value: item.value_code,
          text: item.value_meaning
        };
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      switch (vsetCode) {
        case 'legal_entity':
          this.legalEntity = this.defaultValue;
          break;
        case 'period':
          this.periodFrom = null;
          break;
        case 'periodTo':
          this.periodTo = null;
          break;
        case 'vendor':
          this.vendorName.text = null;
          this.vendorName.value = null;
          this.po_number = null;
          this.po_currency = null;
          this.po_line_num = null;
          this.item_description = null;
          break;
        case 'po_number':
          this.poNum = null;
          break;
        case 'account_code':
          this.concatenatedSegment.text = null;
          this.concatenatedSegment.value = null;
          break;
        case 'account_num':
          this.accountNo = null;
          this.accountNo = null;
          break;
        case 'cost_center':
          this.costCenter = null;
          break;
        case 'expenseMonth':
          this.cfPeriod = null;
          break;
        case 'lob':
          this.lob = null;
          break;
        case 'DEPARTMENT':
          this.department.text = null;
          this.department.value = null;
      }
    },
    showHideApproveRejectModal(flag, type) {
      this.showApproveRejectModal = flag;
      this.approvRejectType = type;
    },
    approveRejectProvisons(status) {
      const payload = {
        event_id: this.carryForwardRowDetails ? this.carryForwardRowDetails.wf_event_id : this.wfCarryForwardDetails ? this.wfCarryForwardDetails.wf_event_id : null,
        wf_inprocess_dtl_id: this.carryForwardRowDetails ? this.carryForwardRowDetails.wf_inprocess_dtl_id : this.wfCarryForwardDetails ? this.wfCarryForwardDetails.wf_inprocess_dtl_id : null,
        notification_status: status,
        notification_comments:
          status === 'REJECTED' ? this.rejectedReason : this.approvalReason
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/approvalRejectSingle', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            if (status === 'REJECTED') {
              this.showHideApproveRejectModal(false);
            } else if (status === 'APPROVED') {
              this.showHideApproveRejectModal(false);
            }
            this.getUpdatedCarryForwardDtlById();
            this.getCarryForwardHdrById();
            if (this.approvalStatus === 'APPROVED') {
              this.getApprovedBatchCarryForward();
            }
            // this.$emit('updateInvoice');
          } else {
            this.showAlert = false;
            alert(response.response.data.message);
            // this.isSuccess = false;
            // this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getApprovedBatchCarryForward() {
      const payload = {
        cf_hdr_id: this.carryForwardRowDetails ? this.cfHdrId : this.wfCarryForwardDetails ? this.cfHdrId : null,
      }
      this.loader = true;
      this.$store
        .dispatch('provisionsAdmin/getApprovedBatchCarryForward', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.ouName = resp.data.data.ou_name;
            this.requestName = resp.data.data.request_name;
            this.respName = resp.data.data.resp_name;
            this.leIdRequest1 = resp.data.data.argument1;
            this.pathRequest2 = resp.data.data.argument2;
            this.hdrIdRequest3 = resp.data.data.argument3;
            this.successMsg = resp.data.data.success_msg;
            this.provisionSubmitRequest();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    provisionSubmitRequest(){
      const payload = {
        InputParameters: [
          {
            REQUEST_NAME: this.requestName,
            OU_NAME: this.ouName,
            USER_NAME: "",
            RESP_NAME: this.respName,
            ARGUMENT1: this.leIdRequest1,
            ARGUMENT2: this.pathRequest2,
            ARGUMENT3: this.hdrIdRequest3,
            ARGUMENT4: "",
            ARGUMENT5: "",
            ARGUMENT6: "",
            ARGUMENT7: "",
            ARGUMENT8: "",
            ARGUMENT9: "",
            ARGUMENT10: "",
            ARGUMENT11: "",
            ARGUMENT12: "",
            ARGUMENT13: "",
            ARGUMENT14: "",
            ARGUMENT15: ""
          }
        ]
      };
      this.loader = true;
      this.$store
        .dispatch('provisionsAdmin/provisionSubmitRequest', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
          } else {
            this.showAlert = false;
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    // getAccCodeDetails() {
    //   const payload = {
    //     _page: 0,
    //     _limit: 100,
    //     po_num: this.poNum,
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('provisionsAdmin/getAccCodeDetails', payload)
    //     .then(resp => {
    //       this.loader = false;
    //       if (resp.status === 200) {
    //         const result = resp.data.data.page;
    //         const accSegment = result[0].concatenated_segments;
    //         const splitSegment = accSegment.split('.');
    //         this.addCarryForwardData[this.segmentIndex].company = splitSegment[0];
    //         // this.addCarryForwardData[this.segmentIndex].lob = splitSegment[1];
    //         // this.addCarryForwardData[this.segmentIndex].department = splitSegment[2];
    //         // this.addCarryForwardData[this.segmentIndex].state_code = splitSegment[3];
    //         // this.addCarryForwardData[this.segmentIndex].cost_center = splitSegment[4];
    //         // this.addCarryForwardData[this.segmentIndex].account_num = splitSegment[5];
    //         // this.addCarryForwardData[this.segmentIndex].sub_account_num = splitSegment[6];
    //         // this.addCarryForwardData[this.segmentIndex].po_distribution_id = null;
    //         // this.getAccNoDetails(result[0].po_distribution_id);
    //       }
    //       this.addCarryForwardData = JSON.parse(JSON.stringify(this.addCarryForwardData))

    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    // getAccNoDetails(poDistributionId) {
    //   const payload = {
    //     _page: 0,
    //     _limit: 100,
    //     account_num: this.addCarryForwardData[this.segmentIndex].account_num,
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('provisionsAdmin/getAccNoDetails', payload)
    //     .then(resp => {
    //       this.loader = false;
    //       if (resp.status === 200) {
    //         const result = resp.data.data.page;
    //         const isIdPresent = this.addCarryForwardData.some(obj => obj.po_distribution_id == poDistributionId);
    //         if (!isIdPresent) {
    //           this.addCarryForwardData[this.segmentIndex].po_distribution_id = poDistributionId;
    //           this.addCarryForwardData[this.segmentIndex].account_desc = result[0].account_desc;
    //         } else {
    //           alert('Distribution id already selected');
    //           this.addCarryForwardData[this.segmentIndex].po_number = null,
    //             this.addCarryForwardData[this.segmentIndex].po_currency = null,
    //             this.addCarryForwardData[this.segmentIndex].po_line_num = null,
    //             this.addCarryForwardData[this.segmentIndex].item_description = null,
    //             this.addCarryForwardData[this.segmentIndex].account_num = null;
    //           this.addCarryForwardData[this.segmentIndex].sub_account_num = null;
    //           this.addCarryForwardData[this.segmentIndex].account_desc = null;
    //           this.addCarryForwardData[this.segmentIndex].company = null,
    //             this.addCarryForwardData[this.segmentIndex].lob = null,
    //             this.addCarryForwardData[this.segmentIndex].department = null,
    //             this.addCarryForwardData[this.segmentIndex].state = null,
    //             this.addCarryForwardData[this.segmentIndex].cost_centre = null
    //         }
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    // getLobCompanyDepartmentDetails() {
    //   const payload = {
    //     state_code: this.addCarryForwardData[this.segmentIndex].state_code,
    //     cost_center: this.addCarryForwardData[this.segmentIndex].cost_center,
    //     // account_number: this.addCarryForwardData[this.segmentIndex].account_num,
    //     // subaccount_number: this.addCarryForwardData[this.segmentIndex].sub_account_num
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('provisionsAdmin/getLobCompanyDepartmentDetails', payload)
    //     .then(resp => {
    //       this.loader = false;
    //       if (resp.status === 200) {
    //         const result = resp.data.data.page;
    //         this.addCarryForwardData[this.segmentIndex].company = result[0].company;
    //         this.addCarryForwardData[this.segmentIndex].lob = result[0].lob;
    //         this.addCarryForwardData[this.segmentIndex].department = result[0].department;
    //       }
    //       this.addCarryForwardData = JSON.parse(JSON.stringify(this.addCarryForwardData))
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    // getProvisionAccountMappingData(accNum, index) {
    //   const payload = {
    //     account_num: accNum,
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('provisionsAdmin/getProvisionAccountMappingData', payload)
    //     .then(resp => {
    //       this.loader = false;
    //       if (resp.status === 200) {
    //         const result = resp.data.page;
    //         this.addCarryForwardData[index].prov_acc_num = result[0].prov_acc_num;
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    clear() {
      this.legalEntity = this.defaultValue;
      this.periodFrom = null;
      this.periodTo = null;
      this.vendorName = this.defaultValue;
      this.poNum = null;
      this.costCenter = null;
      this.accountNo = null;
      this.concatenatedSegment = this.defaultValue;
      this.lob = null;
      this.department = this.defaultValue;
      this.carryForwardData = [];
      this.totalRows = null;
      this.currentPage = 1;
    },
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};